import { ApiEndpoints } from "@shared/api/api-endpoints";
import { wxApiClient } from "@shared/api/clients/apiClientFactory";
import { JobCardFilters } from "./types";

export const dashboardApi = {
  // WX Dashboard APIs
  getDashboardOverview: async (params: {
    remote_utility_id: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "wx",
      "dashboard/overview",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
      }
    );
    const response = await wxApiClient.get(url);
    return response.data;
  },

  getDashboardServiceOrders: async (params: {
    remote_utility_id: string;
    days: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "wx",
      "dashboard/service-orders",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
        qs.push("days", params.days);
      }
    );
    const response = await wxApiClient.get(url);
    return response.data;
  },

  getDashboardSlaPerformance: async (params: {
    remote_utility_id: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "wx",
      "dashboard/sla-performance",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
      }
    );
    const response = await wxApiClient.get(url);
    return response.data;
  },

  getDashboardSopBySource: async (params: {
    remote_utility_id: string;
    days: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "wx",
      "dashboard/sop-by-source",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
        qs.push("days", params.days);
      }
    );
    const response = await wxApiClient.get(url);
    return response.data;
  },

  getDashboardSopCost: async (params: {
    remote_utility_id: string;
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "wx",
      "dashboard/sop-cost",
      (qs) => {
        qs.push("remote_utility_id", params.remote_utility_id);
      }
    );
    const response = await wxApiClient.get(url);
    return response.data;
  },

  getDashboardRecentJobCards: async (filters: JobCardFilters): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "wx",
      "dashboard/recent-job-cards",
      (query) => {
        // Add remote utility ID
        query.push("remote_utility_id", filters.utilityId);

        // Add pagination (with defaults)
        query.push("page", (filters.page || 1).toString());
        query.push("limit", (filters.limit || 5).toString());

        // Add search if provided
        if (filters.search_data) {
          query.push("search_data", filters.search_data);
        }

        // Add status if provided
        if (filters.status) {
          query.push("status", filters.status);
        }
      }
    );

    const response = await wxApiClient.get(url);
    return response.data;
  },
};
